export const comments_4322233 = {"data":{"data":[],"links":{}}}